'use strict';

function getSortOrderIndex(chr, sortOrder) {
  if (!chr) {
    return null;
  } else {
    return sortOrder.indexOf(chr);
  }
}

module.exports = getSortOrderIndex;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/array/internal/getSortOrderIndex.js
// module id = 750
// module chunks = 1